import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { HeatmapPage } from '../../pages/HeatmapPage';
import { GeneralStimmenPage } from '../../pages/GeneralStimmenPage';
import { ActionHubPage } from '../../pages/ActionHubPage';
import { StrategicAdvisorPage } from '../../pages/StrategicAdvisorPage';
import { PersonalReputationPage } from '../../pages/PersonalReputationPage';
import { InvestitionReputationPage } from '../../pages/InvestitionReputationPage';
import { ServicesReputationPage } from '../../pages/ServicesReputationPage';
import { CompetitorRadarPage } from '../../pages/CompetitorRadarPage';
import { KonzernStimmungPage } from '../../pages/KonzernStimmungPage';
import { MarktStimmungPage } from '../../pages/MarktStimmungPage';
// Placeholder component for pages not yet implemented
function PlaceholderPage({
  title,
  description
}: {
  title: string;
  description: string;
}) {
  return <div className="flex-1 flex items-center justify-center p-8" data-id="element-1">
      <div className="text-center max-w-md" data-id="element-2">
        <div className="w-16 h-16 rounded-2xl bg-lidl-blue/10 flex items-center justify-center mx-auto mb-4" data-id="element-3">
          <svg className="w-8 h-8 text-lidl-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" data-id="element-5" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-6">{title}</h2>
        <p className="text-gray-500 text-sm" data-id="element-7">{description}</p>
        <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 bg-lidl-yellow/20 text-lidl-blue text-sm font-medium rounded-lg" data-id="element-8">
          <span className="w-2 h-2 rounded-full bg-lidl-yellow animate-pulse" data-id="element-9"></span>
          In Entwicklung
        </div>
      </div>
    </div>;
}
export function DashboardLayout() {
  const [activeTab, setActiveTab] = useState('heatmap');
  const [isCollapsed, setIsCollapsed] = useState(false);
  // Shared market selection state for Markt-Reputation pages
  const [selectedMarket, setSelectedMarket] = useState<string | null>(null);
  const renderPage = () => {
    switch (activeTab) {
      // General
      case 'heatmap':
        return <HeatmapPage data-id="element-10" />;
      case 'general-stimmen':
        return <GeneralStimmenPage data-id="element-11" />;
      // Konzern-Reputation
      case 'konzern-stimmung':
        return <KonzernStimmungPage data-id="element-12" />;
      // Markt-Reputation - shared market selection
      case 'markt-stimmung':
        return <MarktStimmungPage selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} data-id="element-13" />;
      case 'bewertungs-hub':
        return <ActionHubPage selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} data-id="element-14" />;
      // Analytics
      case 'umsatz-reputation':
        return <StrategicAdvisorPage data-id="element-15" />;
      case 'personal-reputation':
        return <PersonalReputationPage data-id="element-16" />;
      case 'investition-reputation':
        return <InvestitionReputationPage data-id="element-17" />;
      case 'services-reputation':
        return <ServicesReputationPage data-id="element-18" />;
      // Wettbewerb
      case 'wettbewerbsradar':
        return <CompetitorRadarPage data-id="element-19" />;
      default:
        return <HeatmapPage data-id="element-20" />;
    }
  };
  return <div className="min-h-screen bg-lidl-light flex" data-id="element-21">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} data-id="element-22" />

      {/* Main Content Wrapper - margin synced with sidebar state */}
      <div className="flex-1 flex flex-col transition-all duration-200" style={{
      marginLeft: isCollapsed ? 72 : 280
    }} data-id="element-23">
        <main className="flex-1 relative overflow-hidden" data-id="element-24">{renderPage()}</main>
      </div>
    </div>;
}